import SignupForm from "../../components/Forms/Signup/SignupForm";
import "./custom.css";
import { useEffect, useState } from "react";

const MamFamAccountSignUp = () => {
  const [isLogin, setIsLogin] = useState(true);
  useEffect(() => {
    document.title = "MamFam Sign Up";
  }, []);
  return (
    <div className="login-page-container">
      <div className="login-page-card">
        <div className="card-body text-center">
          <SignupForm setIsLogin={setIsLogin} />
        </div>
      </div>
    </div>
  );
};

export default MamFamAccountSignUp;
